<script>
  // A titled group of fields inside a FormLayout. Renders as a Card with an optional
  // header + description so long forms read as sections rather than one wall.
  let { title = null, description = null, children } = $props()
</script>

<div class="card bg-base-100 border border-base-300">
  {#if title || description}
    <div class="px-5 pt-4">
      {#if title}<h2 class="font-semibold">{title}</h2>{/if}
      {#if description}<p class="text-sm text-base-content/60 mt-0.5">{description}</p>{/if}
    </div>
  {/if}
  <div class="card-body gap-4">{@render children()}</div>
</div>
